import cloneDeep from "lodash/cloneDeep";

import createRestApiClient from "../../utility/createRestApiClient";
import { getCookieData } from "../../utility/cookieHandler/handler";
import {
  LAMBDATEST_BUILD_DATA_LOADING,
  LAMBDATEST_BUILD_DATA_SUCCESS,
  LAMBDATEST_BUILD_DATA_FAILED,
  LAMBDATEST_BUILD_DATA_CLEAR,
  LAMBDATEST_SET_BUILDID_WHILE_FETCHING,
  LAMBDATEST_BUILD_DATA_SILENT_LOADING,
  LAMBDATEST_UPDATE_BUILDNAME_LOADING,
  LAMBDATEST_UPDATE_BUILDNAME_SUCCESS,
  LAMBDATEST_UPDATE_BUILDNAME_FAILED,
  LAMBDATEST_UPDATE_BUILDNAME_CLEAR,
  LAMBDATEST_UPDATE_BUILD_DATA_LOADING,
  LAMBDATEST_UPDATE_BUILD_DATA_SUCCESS,
  LAMBDATEST_UPDATE_BUILD_DATA_FAILED,
  LAMBDATEST_UPDATE_BUILD_FIELD,
  LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_LOADING,
  LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_SUCCESS,
  LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_FAILED,
  LAMBDATEST_UPDATE_ACTIVE_BUILD_TAB,
  LAMBDATEST_FILTER_BUILD_DATA_LOADING,
  LAMBDATEST_FILTER_BUILD_DATA_SUCCESS,
  LAMBDATEST_FILTER_BUILD_DATA_FAILED,
  SET_IS_BUILD_SELECTED_VIA_KEYBOARD,
  LAMBDATEST_DELETE_BUILD_LOCAL,
  LAMBDATEST_UPDATE_BUILD_LIST
} from "../actionTypeConstants/LambdaTestBuildDataConstants";

import { DEFAULT_BUILD_DATA_API_CALL_LIMIT } from "../../common/constants/View";
import { getApiBaseUrl } from "../../utility/utilityFunctions";

const timezoneOffset = getCookieData("timezoneOffset");
export let currentOffsetValue = 0;

export function setCurrentBuildIDWhileFetchingData(buildID) {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_SET_BUILDID_WHILE_FETCHING,
      buildID: buildID
    });
}

export function clearDefaultBuildData() {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_BUILD_DATA_CLEAR
    });
}

export function updateBuildName(buildId, data, automationApiHost) {
  if (!buildId) {
    return false;
  }
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();

  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  let types = [
    LAMBDATEST_UPDATE_BUILDNAME_LOADING,
    LAMBDATEST_UPDATE_BUILDNAME_SUCCESS,
    LAMBDATEST_UPDATE_BUILDNAME_FAILED,
    LAMBDATEST_UPDATE_BUILDNAME_CLEAR
  ];
  const endPoint = `api/v1/build/${buildId}/updatename`;
  let headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };
  return {
    types: types,
    promise: () =>
      mockApiClient.put(
        `${endPoint}`,
        {
          name: data
        },
        {
          headers: headers
        }
      )
  };
}

export const clearUpdateBuildName = () => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_UPDATE_BUILDNAME_CLEAR
  });
};

export function fetchDefaultBuildDataNewDashboard(
  token,
  filter = {},
  minimal = false,
  offset = 0,
  sseEnabled = false,
  shareId = "",
  automationApiHost,
  dataLimit = DEFAULT_BUILD_DATA_API_CALL_LIMIT,
  resetBuildData = false,
  isLtCentralizedProject
) {
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();

  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let accessToken = token;
  if (!accessToken) {
    let cookieName = process.env.REACT_APP_COOKIE_NAME;
    accessToken = getCookieData(cookieName);
  }
  currentOffsetValue = offset;
  const limit = dataLimit;
  let queryString = minimal === true ? `&minimal=true` : ``;
  const updatedFilterObject = cloneDeep(filter);
  Object.keys(updatedFilterObject).forEach(function(k) {
    if (updatedFilterObject[k]) {
      if (
        k === "project" &&
        isLtCentralizedProject &&
        updatedFilterObject[k].length > 0
      ) {
        // convert the array to json string
        const data = updatedFilterObject[k];
        const projectMap = Object.fromEntries(
          data.map(item => {
            const [id, ...nameParts] = item.split(":");
            return [id, nameParts.join(":").trim()];
          })
        );

        const jsonString = JSON.stringify(projectMap, null, 2);
        updatedFilterObject[k] = jsonString;
      }
      if (updatedFilterObject[k] instanceof Array) {
        if (updatedFilterObject[k]?.length > 0) {
          if (k === "status") {
            if (updatedFilterObject[k].includes("error")) {
              ["cancelled,queue_timeout,idle_timeout,lambda error"].forEach(
                function(val) {
                  updatedFilterObject[k].push(val);
                }
              );
            }
            if (
              updatedFilterObject[k].includes("passed") &&
              updatedFilterObject[k].indexOf("success") === -1
            ) {
              ["success"].forEach(function(val) {
                updatedFilterObject[k].push(val);
              });
            }
          }
          queryString = `${queryString}&${k}=${updatedFilterObject[k].join(
            ","
          )}`;
          if (`${k}` === `range`) {
            if (!updatedFilterObject.filterBy) {
              queryString = `${queryString}&filterBy=range`;
            }
          }
        }
      }
      if (
        typeof updatedFilterObject[k] === "string" ||
        updatedFilterObject[k] instanceof String
      ) {
        if (updatedFilterObject[k].trim() !== "") {
          queryString = `${queryString}&${k}=${encodeURIComponent(
            updatedFilterObject[k]
          )}`;
        }
      }
    }
  });
  let header;
  if (shareId) {
    header = { "x-ml-auth": shareId, "x-ml-user": "sharing-client" };
  } else {
    header = { Authorization: `Bearer ` + accessToken };
  }
  const endPoint =
    queryString && queryString.trim() !== ""
      ? `/api/v2/build?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}${queryString}`
      : `/api/v2/build?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}`;

  let typesArray = [
    LAMBDATEST_BUILD_DATA_LOADING,
    LAMBDATEST_BUILD_DATA_SUCCESS,
    LAMBDATEST_BUILD_DATA_FAILED
  ];
  if (sseEnabled) {
    typesArray = [
      LAMBDATEST_BUILD_DATA_SILENT_LOADING,
      LAMBDATEST_BUILD_DATA_SUCCESS,
      LAMBDATEST_BUILD_DATA_FAILED
    ];
  }

  return {
    types: [...typesArray],
    payload: {
      currentOffsetValue,
      limit: dataLimit,
      resetBuildData: resetBuildData
    },
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: header
      })
  };
}

export function fetchBuildWithUniqueTests(
  token,
  buildId,
  filter = {},
  minimal = false,
  offset = 0,
  shareId = "",
  automationApiHost
) {
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();

  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let accessToken = token;
  if (!accessToken) {
    let cookieName = process.env.REACT_APP_COOKIE_NAME;
    accessToken = getCookieData(cookieName);
  }
  currentOffsetValue = offset;
  const limit = DEFAULT_BUILD_DATA_API_CALL_LIMIT;
  let queryString = minimal === true ? `&minimal=true` : ``;
  const updatedFilterObject = cloneDeep(filter);
  Object.keys(updatedFilterObject).forEach(function(k) {
    if (updatedFilterObject[k]) {
      if (updatedFilterObject[k] instanceof Array) {
        if (updatedFilterObject[k]?.length > 0) {
          queryString = `${queryString}&${k}=${updatedFilterObject[k].join(
            ","
          )}`;
        }
      }
    }
  });
  let header;
  if (shareId) {
    header = { "x-ml-auth": shareId, "x-ml-user": "sharing-client" };
  } else {
    header = { Authorization: `Bearer ` + accessToken };
  }
  const endPoint =
    queryString && queryString.trim() !== ""
      ? `/api/v2/build?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}${queryString}`
      : `/api/v2/build?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}`;
  let typesArray = [
    LAMBDATEST_FILTER_BUILD_DATA_LOADING,
    LAMBDATEST_FILTER_BUILD_DATA_SUCCESS,
    LAMBDATEST_FILTER_BUILD_DATA_FAILED
  ];

  return {
    types: [...typesArray],
    payload: { buildId, currentOffsetValue },
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: header
      })
  };
}

export const getBuild = (
  buildId = "",
  testTags = "",
  token,
  automationApiHost
) => {
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();

  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let accessToken = token;
  if (!accessToken) {
    let cookieName = process.env.REACT_APP_COOKIE_NAME;
    accessToken = getCookieData(cookieName);
  }
  const limit = 10;
  const header = { Authorization: `Bearer ` + accessToken };
  let endPoint = `/api/v2/build?timezone=${timezoneOffset}&offset=0&limit=${limit}&build=${buildId}`;
  if (testTags) {
    endPoint += `&testTag=${testTags}`;
  }
  const typesArray = [
    LAMBDATEST_UPDATE_BUILD_DATA_LOADING,
    LAMBDATEST_UPDATE_BUILD_DATA_SUCCESS,
    LAMBDATEST_UPDATE_BUILD_DATA_FAILED
  ];
  return {
    types: [...typesArray],
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: header
      })
  };
};

export const updateBuildField = (
  buildId = "",
  fieldToUpdate = "",
  data = ""
) => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_UPDATE_BUILD_FIELD,
    payload: { buildId, fieldToUpdate, data }
  });
};

export const updateBuildList = (buildList, isNewBuild, isBuildUpdatedEvent) => (
  dispatch: Dispatch
) => {
  dispatch({
    type: LAMBDATEST_UPDATE_BUILD_LIST,
    payload: { buildList, isNewBuild, isBuildUpdatedEvent }
  });
};

export function loadSampleBuild({ language, automationApiHost }) {
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();

  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  let endPoint = `/api/v2/build?framework=${language}`;
  const header = {
    Authorization: `Bearer ` + access_token
  };
  let types = [
    LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_LOADING,
    LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_SUCCESS,
    LAMBDATEST_LOAD_SAMPLE_BUILD_DATA_FAILED
  ];
  return {
    types: types,
    promise: () =>
      mockApiClient.get(`${endPoint}`, {
        headers: header
      })
  };
}

export const updateActiveBuildTab = (tabName = "") => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_UPDATE_ACTIVE_BUILD_TAB,
    payload: { tabName }
  });
};

export const setIsBuildSelectedViaKeyboard = (
  isSelectedViaKeyboard = false
) => (dispatch: Dispatch) => {
  dispatch({
    type: SET_IS_BUILD_SELECTED_VIA_KEYBOARD,
    payload: { isSelectedViaKeyboard }
  });
};

export const deleteFromList = buildId => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_DELETE_BUILD_LOCAL,
      payload: buildId
    });
};
